// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import ProjectMenu from './Project'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectAu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='6' />
                <div className='dv_project_body'>
                    <ProjectMenu activeMenu={5} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/projects/107.jpg")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>澳⼤利亚简介</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>项目简介</div>
                                    <div className={this.state.currentTab == 2 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>合作院校</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/108.jpg")} />

                                    </div>

                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/109.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/110.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/111.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/112.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/113.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/114.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/115.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/116.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/117.jpg")} />
                                    </div>

                                </div>}
                                {this.state.currentTab == 2 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/118.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/119.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/120.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/121.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/122.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/123.jpg")} />

                                    </div>

                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectAu);